import { RootState } from 'types'
import { TimelineEvent } from 'screens/Activity/Types'

export const setTimeline = (value: RootState['timeline']) => {
  const payload = { timeline: value }
  return { type: 'TIMELINE_SET', payload }
}
export const addOlderEventToTimeline = (value: RootState['timeline']) => {
  const payload = { timeline: value }
  return { type: 'LOAD_MORE_ON_TIMELINE', payload }
}

export const updateTimelineEvent = (event: TimelineEvent) => {
  return { type: 'UPDATE_TIMELINE_EVENT', payload: { event } }
}

export const resetTimeline = () => {
  return { type: 'TIMELINE_RESET' }
}
